<template>
    <div>
        <div class="row">
            <div class="col-12 col-md-7 mb-md-1">
                <portfolio-buttons/>
            </div>
            <div class="col-12 col-md-5 mb-md-1">
                <div class="transactions-filters portfolio-buttons">
                    <transactions-type-picker v-if="currentRoute === 'transactions'" />
                    <transactions-date-picker />
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12 col-md-3">
                <div class="card">
                    <div class="card-body p-0">
                        <ul class="vertical-nav">
                            <li>
                                <router-link :to="{ name: 'transactions' }">Transakcie</router-link>
                            </li>
                            <li>
                                <router-link :to="{ name: 'trades' }">Obchody</router-link>
                            </li>
                            <li>
                                <router-link :to="{ name: 'conversions' }">Konverzie</router-link>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="col-12 col-md-9">
                <router-view :portfolio="currentPortfolio ? currentPortfolio.portfolio : null" :from="from" :to="to" />
            </div>
        </div>
    </div>
</template>

<script>
import PortfolioButtons from "../../../components/PortfolioButtons";
import TransactionsDatePicker from "../../../components/TransactionsDatePicker";
import TransactionsTypePicker from "../../../components/TransactionsTypePicker";

export default {
	name: "Transactions",
	components: {
		PortfolioButtons,
		TransactionsDatePicker,
		TransactionsTypePicker,
	},
	computed: {
		currentRoute() {
			return this.$route.name;
		},
        currentPortfolio() {
            return this.$store.state.portfolio.selected;
        }
	},
	data() {
		return {
			from: null,
			to: null,
		};
	},
};
</script>

<style lang="scss">
@import "@/assets/styles/variables.scss";
.transactions-filters {
	float: right;
	margin-top: 15px;
	display: flex;

    @include media-breakpoint-down(md) {
        float: left;
        margin-top: 0px;
    }
}
</style>
